// extracted by mini-css-extract-plugin
module.exports = {"column-stats":"column-stats","column":"column","stats-container":"stats-container","title":"title","icon":"icon","menu-list":"menu-list"};